import authRules from '../authRules.js';

const viewTourSalaryLevelUpgrade = (user) => {
  const { tourSalaryUpgradeAccounting } = user.securityLevels;
  if (tourSalaryUpgradeAccounting >= authRules.viewTourSalaryLevelUpgrade.tourSalaryUpgradeAccounting) {
      return true;
  } else {
      return false;
    }
  }


export default viewTourSalaryLevelUpgrade;